import { create } from 'zustand';

type RfidState = {
  rfIdRegistrationSerialNumber: string;
  currentTagName: string;
  currentSerialNumber: string;
  rfidSocketNumber: string;
};

type RfidActions = {
  setRfIdRegistrationSerialNumber: (serialNumber: string) => void;
  setCurrentTagName: (tagName: string) => void;
  setCurrentSerialNumber: (serialNumber: string) => void;
  setRfidSocketNumber: (socketNumber: string) => void;
};

export const useRfidStore = create<RfidState & RfidActions>()((set) => ({
  rfIdRegistrationSerialNumber: '',
  currentTagName: '',
  currentSerialNumber: '',
  rfidSocketNumber: '',
  setRfIdRegistrationSerialNumber: (serialNumber) =>
    set({ rfIdRegistrationSerialNumber: serialNumber }),
  setCurrentTagName: (tagName) => set({ currentTagName: tagName }),
  setCurrentSerialNumber: (serialNumber) =>
    set({ currentSerialNumber: serialNumber }),
  setRfidSocketNumber: (socketNumber) =>
    set({ rfidSocketNumber: socketNumber }),
}));
